/** @type {0} */ export const UNDECIDED = 0;
/** @type {1} */ export const TRUSTED = 1;
/** @type {-1} */ export const UNTRUSTED = -1;

export const TAG_LENGTH = 128;

export const KEY_ALGO = {
    name: 'AES-GCM',
    length: 128,
};
